import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import { FC } from 'react';
import Button from './Button';
import { useThemeContext } from 'shared/context/themeContext';
import {
  dark as darkColors,
  light as lightColors
} from 'shared/theme/colorTokens';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  body: string;
  onRemove: () => void;
}

const DeleteModal: FC<Props> = ({ open, onClose, title, body, onRemove }) => {
  const { theme } = useThemeContext();
  const isDarkTheme = theme === 'dark';
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          backgroundColor: isDarkTheme
            ? darkColors.modalBackground
            : lightColors.modalBackground,
          borderRadius: '15px',
          boxShadow:
            '0px 0px 25px 0px rgba(255, 0, 0, 1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <DialogTitle className="text-lg font-semibold text-ink dark:text-ink-dark">
        {title}
      </DialogTitle>
      <DialogContent>
        <p className="text-sm text-ink dark:text-ink-dark">{body}</p>
      </DialogContent>
      <DialogActions>
        <Button variant="secondary" size="sm" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="danger" size="sm" onClick={onRemove}>
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
